import Vue from "vue";
import App from "./App";
import router from "./router";
import iView from "iview";
import "iview/dist/styles/iview.css";
import md5 from "js-md5";

import "!style-loader!css-loader!less-loader!../src/components/main/main.less";
import "!style-loader!css-loader!less-loader!../src/components/uistyle/uistyle.less";

import VueCookies from "vue-cookies";
Vue.use(VueCookies);

//vuex
import store from "./store";
Vue.prototype.md5 = md5;

Vue.use(iView);

Vue.config.productionTip = false;
// 全局方法的注册
import MyPlugin from "./utils/common";
Vue.use(MyPlugin);

import { getEnv } from "./utils/env";
var env = getEnv();
Vue.prototype.GLOBAL = env + "/data-base/";
Vue.prototype.GLOBALStockS = env + "/stock-service/";
Vue.prototype.GLOBALTrace = env + "/trace-data/";
Vue.prototype.GLOBALProduceS = env + "/produce-service/";
Vue.prototype.GLOBALheinz = env + "/customize-heinz/";
Vue.prototype.GLOBALCode = env + "/apply-code/";
Vue.prototype.BASE_URL = env;
import * as methods from "./utils/methods"; //整体加载 fns.方法 使用
Object.keys(methods).forEach((key) => {
  Vue.prototype["$" + key] = methods[key];
});
// 仓储加号字体样式文件
import "font-awesome/css/font-awesome.css";
//特殊字符正则
Vue.prototype.reg = new RegExp(
  "[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]"
);
// 纯数字正则
Vue.prototype.numReg = new RegExp(/^[0-9]*$/);
// 全局企业code 表
import easeCodeGlobal from "./easeCodeGlobal.js";
Vue.prototype.easeCodeGlobal = easeCodeGlobal;
// 通用弹窗图标
Vue.prototype.currencyIcon = require("./assets/images/currencyIcon.png");
Vue.prototype.pagecount = 10; // 每页显示条数常量
// var devtoken = '901f851621c04ee7da65ee17eb3cfcca'//dev环境token
var devtoken = "281a10a70c6768fec8649705c8d2d060"; //生产环境token
import axios from "axios";
Vue.prototype.axios = axios;
axios.interceptors.request.use(
  function (config) {
    //在请求发出之前进行一些操作
    let token = localStorage.getItem(devtoken);
    config.headers["token"] = token;

    return config;
  },
  (error) => {
    console.log(error); // for debug
  }
);
axios.interceptors.response.use(
  (response) => {
    if (response.data.code == 401) {
      //清除sessionStorage
      store.dispatch("logout").then((res) => {
        window.location.href = localStorage.getItem("hostUrl"); //localStorage.getItem("hostName")
      });
    }
    //  else if(localStorage.getItem("userName")==null) {
    //   console.log(localStorage.getItem("userName"),'ffffff',localStorage.getItem('hostUrl'))
    //   window.location.href = localStorage.getItem('hostUrl');
    // }
    return response;
  },
  (error) => {
    console.log(error, "error");
    return error.code ? Promise.reject(error) : error;
  }
);

axios.defaults.headers.common["token"] = localStorage.getItem(devtoken); //token
Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js